// Spectate bar (ui-qol §2.3): bottom-centre, ≈ 366u × 36u, black 38 %, radius 7u, 15u Ubuntu
// white: "Press Q to switch the spectate camera". Shown only while spectating.
//
// Consumer: app.ts.

import { h, show } from '../dom.js';
import { t } from '../i18n/t.js';

export interface SpectateBar {
  readonly el: HTMLElement;
  setVisible(visible: boolean): void;
}

/** The bar text: the Q hint, or the touch camera-button hint on touch devices. */
export function spectateHintText(touch: boolean): string {
  return t(touch ? 'hud.spectateHint.touch' : 'hud.spectateHint');
}

export function createSpectateBar(touch = false): SpectateBar {
  const el = h('div', { class: 'hud-spectate-bar', hidden: true }, spectateHintText(touch));
  return {
    el,
    setVisible(visible: boolean): void {
      if (el.hidden === !visible) return;
      show(el, visible);
    },
  };
}
